import type { CSSProperties } from 'react';

import { CATEGORY_LABELS, glyphOf, type Category } from '@/papermill/extraction';

import styles from './EntityTypeBadge.module.css';

export interface EntityTypeBadgeProps {
  typeLabel: string;
  category: Category;
}

/** What kind of entity this is, in the colour and initials it wears in the graph. */
export function EntityTypeBadge({ typeLabel, category }: EntityTypeBadgeProps) {
  return (
    <span
      className={styles.badge}
      style={{ '--node-color': `var(--series-${category})` } as CSSProperties}
    >
      <span className={styles.glyph} aria-hidden="true">
        {glyphOf(typeLabel)}
      </span>
      <span className={styles.type}>{typeLabel}</span>
      <span className={styles.category}>{CATEGORY_LABELS[category]}</span>
    </span>
  );
}
